import { AxiosInstance, AxiosResponse } from 'axios';
import ColisportApiResource from './colisport-api-resource.model';
import {
  CreateMailCampaignDto,
  GetCampaignsDto,
  MailCampaign,
  SendMailCampaignDto,
} from '../../models/mail-campaign.model';

export default class MailCampaignsApi implements ColisportApiResource {
  readonly apiUrlPath = 'email/campaigns';

  constructor(readonly httpClient: AxiosInstance) {}

  async createGlsCampaign(dto: CreateMailCampaignDto): Promise<AxiosResponse<MailCampaign>> {
    return this.httpClient.post(`${this.apiUrlPath}`, dto);
  }

  async getCampaigns(): Promise<AxiosResponse<GetCampaignsDto>> {
    return this.httpClient.get(`${this.apiUrlPath}`);
  }

  async executeCampaign(dto: SendMailCampaignDto): Promise<AxiosResponse<any>> {
    return this.httpClient.post(`${this.apiUrlPath}/send`, dto);
  }
}
